// extracted by mini-css-extract-plugin
export default {"form":"style_form__vdjkQ","input-container":"style_input-container__Lp0z1","input":"style_input__inJLb","input-button":"style_input-button__ltxiJ"};